import { useEffect, useState } from "react";

/** True when the media query matches. False where matchMedia is unavailable, such as in tests. */
export const useMediaQuery = (query: string): boolean => {
	const supported = typeof window !== "undefined" && typeof window.matchMedia === "function";
	const [matches, setMatches] = useState(() => (supported ? window.matchMedia(query).matches : false));

	useEffect(() => {
		if (!supported) {
			return;
		}
		const media = window.matchMedia(query);
		const onChange = () => setMatches(media.matches);
		onChange();
		media.addEventListener("change", onChange);
		return () => media.removeEventListener("change", onChange);
	}, [query, supported]);

	return matches;
};

export const DESKTOP_QUERY = "(min-width: 900px)";
